<template>
<zj-layout-container>
  <zj-layout-main>
    <div class="zj-layout-main-content bgcolor scrollable" ref="container">
      电子地图
    </div>
  </zj-layout-main>
</zj-layout-container>
</template>

<script>
export default {
  name: 'Home',
  controller: 'UI',
  action: 'Home'
}
</script>
